import { AlertType, Icons } from 'bold-ui'
import {
  GrupoCondicaoEnum,
  IdentidadeGeneroEnum,
  NacionalidadeEnum,
  OrientacaoSexualEnum,
  SexoEnum,
  TipoAcesso,
  TipoColetaGlicemia,
  TipoReceitaEnum,
  TipoSanguineoEnum,
  TurnoEnum,
} from 'graphql/types.generated'

export const tipoAcesso: Record<TipoAcesso, string> = {
  [TipoAcesso.ADMINISTRADOR_GERAL]: 'Instalador',
  [TipoAcesso.ADMINISTRADOR_MUNICIPAL]: 'Administrador municipal',
  [TipoAcesso.GESTOR_ESTADUAL]: 'Gestor estadual',
  [TipoAcesso.GESTOR_MUNICIPAL]: 'Gestor municipal',
  [TipoAcesso.LOTACAO]: 'Lotação',
}

export const identidadeGenero: Record<IdentidadeGeneroEnum, string> = {
  [IdentidadeGeneroEnum.HOMEM_TRANS]: 'Homem transsexual',
  [IdentidadeGeneroEnum.MULHER_TRANS]: 'Mulher transsexual',
  [IdentidadeGeneroEnum.TRAVESTI]: 'Travesti',
  [IdentidadeGeneroEnum.OUTRO_IDENTIDADE_GENERO]: 'Outro',
}

export const sexo: Record<SexoEnum, string> = {
  [SexoEnum.MASCULINO]: 'Masculino',
  [SexoEnum.FEMININO]: 'Feminino',
  [SexoEnum.IGNORADO]: 'Ignorado',
  [SexoEnum.AMBOS]: 'Ambos',
  [SexoEnum.NAO_INFORMADO]: 'Não informado',
}

export const tipoSanguineo: Record<TipoSanguineoEnum, string> = {
  [TipoSanguineoEnum.A_POSITIVO]: 'A+',
  [TipoSanguineoEnum.A_NEGATIVO]: 'A-',
  [TipoSanguineoEnum.B_POSITIVO]: 'B+',
  [TipoSanguineoEnum.B_NEGATIVO]: 'B-',
  [TipoSanguineoEnum.AB_POSITIVO]: 'AB+',
  [TipoSanguineoEnum.AB_NEGATIVO]: 'AB-',
  [TipoSanguineoEnum.O_POSITIVO]: 'O+',
  [TipoSanguineoEnum.O_NEGATIVO]: 'O-',
}

export const orientacaoSexual: Record<OrientacaoSexualEnum, string> = {
  [OrientacaoSexualEnum.HETEROSSEXUAL]: 'Heterossexual',
  [OrientacaoSexualEnum.HOMOSSEXUAL]: 'Homossexual (gay / lésbica)',
  [OrientacaoSexualEnum.BISSEXUAL]: 'Bissexual',
  [OrientacaoSexualEnum.OUTRO_ORIENTACAO_SEXUAL]: 'Outro',
}

export const nacionalidade: Record<NacionalidadeEnum, string> = {
  [NacionalidadeEnum.BRASILEIRA]: 'Brasileira',
  [NacionalidadeEnum.NATURALIZADA]: 'Naturalizado',
  [NacionalidadeEnum.ESTRANGEIRA]: 'Estrangeiro',
}

export const grupoCondicao: Record<GrupoCondicaoEnum, string> = {
  [GrupoCondicaoEnum.ASMA]: 'Asma',
  [GrupoCondicaoEnum.AVC]: 'AVC',
  [GrupoCondicaoEnum.DENGUE]: 'Dengue',
  [GrupoCondicaoEnum.DESNUTRICAO]: 'Desnutrição',
  [GrupoCondicaoEnum.DIABETES]: 'Diabetes',
  [GrupoCondicaoEnum.DOENCA_CARDIACA]: 'Doença cardíaca',
  [GrupoCondicaoEnum.DPOC]: 'DPOC',
  [GrupoCondicaoEnum.DST]: 'DST',
  [GrupoCondicaoEnum.HANSENIASE]: 'Hanseníase',
  [GrupoCondicaoEnum.HIPERTENSAO_ARTERIAL]: 'Hipertensão arterial',
  [GrupoCondicaoEnum.OBESIDADE]: 'Obesidade',
  [GrupoCondicaoEnum.GRAVIDEZ]: 'Gravidez',
  [GrupoCondicaoEnum.INFARTO]: 'Infarto',
  [GrupoCondicaoEnum.REABILITACAO]: 'Reabilitação',
  [GrupoCondicaoEnum.RINS]: 'Rins',
  [GrupoCondicaoEnum.SAUDE_MENTAL]: 'Saúde mental',
  [GrupoCondicaoEnum.SAUDE_SEXUAL_E_REPRODUTIVA]: 'Saúde sexual e reprodutiva',
  [GrupoCondicaoEnum.TABAGISMO]: 'Tabagismo',
  [GrupoCondicaoEnum.TUBERCULOSE]: 'Tuberculose',
  [GrupoCondicaoEnum.USUARIO_DE_ALCOOL]: 'Usuário de álcool',
  [GrupoCondicaoEnum.USUARIO_DE_OUTRAS_DROGAS]: 'Usuário de outras drogas',
}

export const tipoColetaGlicemia: Record<TipoColetaGlicemia, string> = {
  [TipoColetaGlicemia.JEJUM]: 'Jejum',
  [TipoColetaGlicemia.NAO_ESPECIFICADO]: 'Não especificado',
  [TipoColetaGlicemia.POSPRANDIAL]: 'Pós-prandial',
  [TipoColetaGlicemia.PREPRANDIAL]: 'Pré-prandial',
}

export const idGrupoCondicao: Record<GrupoCondicaoEnum, ID> = {
  [GrupoCondicaoEnum.ASMA]: 1,
  [GrupoCondicaoEnum.AVC]: 2,
  [GrupoCondicaoEnum.DENGUE]: 3,
  [GrupoCondicaoEnum.DESNUTRICAO]: 4,
  [GrupoCondicaoEnum.DIABETES]: 5,
  [GrupoCondicaoEnum.DOENCA_CARDIACA]: 6,
  [GrupoCondicaoEnum.DPOC]: 7,
  [GrupoCondicaoEnum.DST]: 8,
  [GrupoCondicaoEnum.HANSENIASE]: 9,
  [GrupoCondicaoEnum.HIPERTENSAO_ARTERIAL]: 10,
  [GrupoCondicaoEnum.OBESIDADE]: 11,
  [GrupoCondicaoEnum.GRAVIDEZ]: 12,
  [GrupoCondicaoEnum.INFARTO]: 13,
  [GrupoCondicaoEnum.REABILITACAO]: 14,
  [GrupoCondicaoEnum.RINS]: 15,
  [GrupoCondicaoEnum.SAUDE_MENTAL]: 16,
  [GrupoCondicaoEnum.SAUDE_SEXUAL_E_REPRODUTIVA]: 17,
  [GrupoCondicaoEnum.TABAGISMO]: 18,
  [GrupoCondicaoEnum.TUBERCULOSE]: 19,
  [GrupoCondicaoEnum.USUARIO_DE_ALCOOL]: 20,
  [GrupoCondicaoEnum.USUARIO_DE_OUTRAS_DROGAS]: 21,
}

export enum ProcedimentosAutomaticosAtendimentoIndividual {
  MEDICAO_DE_PESO = '0101040083',
  MEDICAO_DE_ALTURA = '0101040075',
  GLICEMIA_CAPILAR = '0214010015',
  AFERICAO_DE_TEMPERATURA = '0301100250',
  AVALIACAO_ANTROPOMETRICA = '0101040024',
  AFERICAO_PRESSAO_ARTERIAL = '0301100039',
  CONSULTA_MEDICA_EM_ATENCAO_BASICA = '0301010064',
  CONSULTA_DE_PROFISSIONAIS_DE_NIVEL_SUPERIOR_NA_ATENCAO_BASICA = '0301010030',
  ATENDIMENTO_DE_URGENCIA_NA_ATENCAO_BASICA = '0301060037',
}

export enum ProcedimentosAutomaticoAtendimentoOdonto {
  PRIMEIRA_CONSULTA_ODONTOLOGICA_PROGRAMATICA = '0301010153',
  ATENDIMENTO_DE_URGENCIA_EM_ATENCAO_ESPECIALIZADA = '0301060061',
  CONSULTA_DE_PROFISSIONAIS_DE_NIVEL_SUPERIOR_NA_ATENCAO_ESPECIALIZADA = '0301010048',
}

export const TipoAlerta = {
  SUCCESS: 'success' as AlertType,
  WARNING: 'warning' as AlertType,
  DANGER: 'danger' as AlertType,
}

export const EstadoNutricional = {
  MAGREZA_ACENTUADA: { message: 'Magreza acentuada', alertType: TipoAlerta.DANGER },
  MAGREZA: { message: 'Magreza', alertType: TipoAlerta.WARNING },
  BAIXO_PESO: { message: 'Baixo Peso', alertType: TipoAlerta.DANGER },
  ADEQUADO: { message: 'Adequado ou Eutrófico', alertType: TipoAlerta.SUCCESS },
  EUTROFICO: { message: 'Eutrofia', alertType: TipoAlerta.SUCCESS },
  RISCO_SOBREPESO: { message: 'Risco de sobrepeso', alertType: TipoAlerta.WARNING },
  SOBREPESO: {
    DANGER: { message: 'Sobrepeso', alertType: TipoAlerta.DANGER },
    WARNING: { message: 'Sobrepeso', alertType: TipoAlerta.WARNING },
  },
  OBESIDADE: {
    DANGER: { message: 'Obesidade', alertType: TipoAlerta.DANGER },
    WARNING: { message: 'Obesidade', alertType: TipoAlerta.WARNING },
  },
  OBESIDADE_GRAVE: { message: 'Obesidade grave', alertType: TipoAlerta.DANGER },
}

export const turnoRecord: Record<TurnoEnum, string> = {
  [TurnoEnum.MANHA]: 'Manhã',
  [TurnoEnum.TARDE]: 'Tarde',
  [TurnoEnum.NOITE]: 'Noite',
}

export const turnoByStringRecord: Record<string, TurnoEnum> = {
  manha: TurnoEnum.MANHA,
  tarde: TurnoEnum.TARDE,
  noite: TurnoEnum.NOITE,
}

export const tipoReceitaRecord: Record<TipoReceitaEnum, string> = {
  [TipoReceitaEnum.COMUM]: 'Comum',
  [TipoReceitaEnum.ESPECIAL]: 'Especial',
  [TipoReceitaEnum.ESPECIAL_AMARELA]: 'Especial - notificação amarela',
  [TipoReceitaEnum.ESPECIAL_AZUL]: 'Especial - notificação azul',
  [TipoReceitaEnum.ESPECIAL_BRANCA]: 'Especial - notificação branca',
}

export const tipoGlicemiaRecord: Record<string, string> = {
  NAOESPECIFICADO: 'Momento da coleta não especificado',
  JEJUM: 'Jejum',
  'PÓS-PRANDIAL': 'Pós-prandial',
  'PRÉ-PRANDIAL': 'Pré-prandial',
}

export enum TermosTalidomidaImpressaoPrescricao {
  ANEXO_V = 'Termo de responsabilidade/esclarecimento - Masc. (qualquer idade)/Fem. (maior que 55 anos)',
  ANEXO_VII = 'Termo de esclarecimento',
  ANEXO_VIII = 'Termo de responsabilidade',
}

export enum TermosOutrosMedicamentosImpressaoPrescricao {
  ANEXO_XV = 'Termo de conhecimentos de risco e consentimento pós-informação - Fem. (menor que 55 anos)',
  ANEXO_XVI = 'Termo de conhecimentos de risco e consentimento pós-informação - Masc. (qualquer idade)/Fem. (maior que 55 anos)',
}

export const termosPrescricaoImpressao: Record<
  TermosTalidomidaImpressaoPrescricao | TermosOutrosMedicamentosImpressaoPrescricao,
  string
> = {
  [TermosTalidomidaImpressaoPrescricao.ANEXO_V]: 'ANEXO_V',
  [TermosTalidomidaImpressaoPrescricao.ANEXO_VII]: 'ANEXO_VII',
  [TermosTalidomidaImpressaoPrescricao.ANEXO_VIII]: 'ANEXO_VIII',
  [TermosOutrosMedicamentosImpressaoPrescricao.ANEXO_XV]: 'ANEXO_XV',
  [TermosOutrosMedicamentosImpressaoPrescricao.ANEXO_XVI]: 'ANEXO_XVI',
}

export enum TipoAtendimento {
  CONSULTA = 'Consulta',
  ESCUTA_INICIAL = 'Escuta inicial',
  CONSULTA_ODONTOLOGICA = 'Consulta odontológica',
  ATENDIMENTO_DOMICILIAR = 'Atendimento domiciliar',
  VISITA_DOMICILIAR_TERRITORIAL = 'Visita domiciliar e territorial',
  PROCEDIMENTO = 'Procedimento',
  VACINACAO = 'Vacinação',
  ATIVIDADE_COLETIVA = 'Atividade coletiva',
  MARCADORES_CONSUMO_ALIMENTAR = 'Marcadores de consumo alimentar',
  AVALIACAO_ELEGIBILIDADE = 'Avaliação de elegibilidade',
  SINDOME_NEUROLOGICA_ZIKA_MICROCEFALIA = 'Síndrome neurológica por zika / microcefalia',
}

interface TipoAtendimentoHistoricoData {
  descricao: string
  colorIcon: string
  colorBar: string
  icon: Icons
}

export const tipoAtendimentoHistorico: Record<string, TipoAtendimentoHistoricoData> = {
  [TipoAtendimento.CONSULTA]: {
    descricao: TipoAtendimento.CONSULTA,
    colorBar: '#0069D0',
    colorIcon: '#0069D0',
    icon: 'nurse',
  },
  [TipoAtendimento.ESCUTA_INICIAL]: {
    descricao: TipoAtendimento.ESCUTA_INICIAL,
    colorBar: '#C8206F',
    colorIcon: '#C8206F',
    icon: 'nurse',
  },
  [TipoAtendimento.CONSULTA_ODONTOLOGICA]: {
    descricao: TipoAtendimento.CONSULTA_ODONTOLOGICA,
    colorBar: '#E76F00',
    colorIcon: '#AD5000',
    icon: 'nurse',
  },
  [TipoAtendimento.ATENDIMENTO_DOMICILIAR]: {
    descricao: TipoAtendimento.ATENDIMENTO_DOMICILIAR,
    colorBar: '#40A42B',
    colorIcon: '#217B00',
    icon: 'houseOutline',
  },
  [TipoAtendimento.VISITA_DOMICILIAR_TERRITORIAL]: {
    descricao: TipoAtendimento.VISITA_DOMICILIAR_TERRITORIAL,
    colorBar: '#40A42B',
    colorIcon: '#217B00',
    icon: 'houseOutline',
  },
  [TipoAtendimento.PROCEDIMENTO]: {
    descricao: TipoAtendimento.PROCEDIMENTO,
    colorBar: '#B58B00',
    colorIcon: '#866600',
    icon: 'bandaidOutline',
  },
  [TipoAtendimento.VACINACAO]: {
    descricao: TipoAtendimento.VACINACAO,
    colorBar: '#B58B00',
    colorIcon: '#866600',
    icon: 'needleOutline',
  },
  [TipoAtendimento.ATIVIDADE_COLETIVA]: {
    descricao: TipoAtendimento.ATIVIDADE_COLETIVA,
    colorBar: '#36A094',
    colorIcon: '#02786D',
    icon: 'imageOutline',
  },
  [TipoAtendimento.MARCADORES_CONSUMO_ALIMENTAR]: {
    descricao: TipoAtendimento.MARCADORES_CONSUMO_ALIMENTAR,
    colorBar: '#36A094',
    colorIcon: '#02786D',
    icon: 'imageOutline',
  },
  [TipoAtendimento.AVALIACAO_ELEGIBILIDADE]: {
    descricao: TipoAtendimento.AVALIACAO_ELEGIBILIDADE,
    colorBar: '#36A094',
    colorIcon: '#02786D',
    icon: 'imageOutline',
  },
  [TipoAtendimento.SINDOME_NEUROLOGICA_ZIKA_MICROCEFALIA]: {
    descricao: TipoAtendimento.SINDOME_NEUROLOGICA_ZIKA_MICROCEFALIA,
    colorBar: '#36A094',
    colorIcon: '#02786D',
    icon: 'imageOutline',
  },
}

export enum ExibirPorHistoricoAtendimentoFilterEnum {
  TODOS_ATENDIMENTOS = 'TODOS_ATENDIMENTOS',
  ULTIMOS_TRINTA_DIAS = 'ULTIMOS_TRINTA_DIAS',
  ULTIMOS_SESSENTA_DIAS = 'ULTIMOS_SESSENTA_DIAS',
  ULTIMOS_NOVENTA_DIAS = 'ULTIMOS_NOVENTA_DIAS',
  ULTIMO_ANO = 'ULTIMO_ANO',
  PERSONALIZADO = 'PERSONALIZADO',
}
